import { FilterOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IContentPart {
  filter: React.ReactNode;
  table: any;
  width?: any;
  setHeight?: (h: number) => void;
}

export const ContentPartFilter = (props: IContentPart) => {
  const { t } = useTranslation();
  let blockHeight: number = window.innerHeight - 150;
  const [filterActive, setFilterActive] = useState<boolean>(false);

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current !== null && props.setHeight !== undefined) {
      let element = ref.current as HTMLElement;
      const filterHeight = filterActive ? 200 : 0;
      props.setHeight(element.clientHeight - filterHeight - 50);
    }
  }, [filterActive, ref]);

  return (
    <div ref={ref} style={{ height: `${blockHeight}px`, position: "relative" }} id='contentPart'>
      <Tooltip placement="top" title="Фильтр" >
        <Button className='filter_btn' title="Фильтр" type="primary" shape="circle" onClick={() => { setFilterActive(!filterActive) }} icon={<FilterOutlined />} />
      </Tooltip>
      <div className="content">
        <div className={`sideFilter  ${filterActive ? "active" : ''}`}>
          <div className="filterContent">
            {props.filter}
          </div>
        </div>
        <div className="sideTable" style={{ width: '100%', height: '100%' }}>
          <div className="tableBlock">
            {React.cloneElement(props.table, { className: "table" })}
          </div>
        </div>
      </div>
    </div>
  );
}
